import Cookies from 'js-cookie';
import { EMPTY_OBJECT } from '../app.constants';
export var setCookie = function setCookie(key, value) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
  return Cookies.set(key, value, attributes);
};
export var removeCookie = function removeCookie(key) {
  return Cookies.remove(key);
};
export var getCookie = function getCookie(key) {
  return Cookies.get(key);
};